module.exports = __webpack_public_path__ + "static/media/cloud-drizzle.6a52aca0.svg";